import { setDefaultOptions } from "date-fns";
import { nb } from "date-fns/locale/nb";
import { WebStorageStateStore } from "oidc-client-ts";
import ReactDOM from "react-dom/client";
import "react-loading-skeleton/dist/skeleton.css";
import { AuthProvider } from "react-oidc-context";
import { BrowserRouter as Router } from "react-router-dom";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import App from "App";
import { ApolloClientProvider } from "config/apollo";

const oidcStateStore = new WebStorageStateStore({
	store: window.localStorage,
});

setDefaultOptions({ locale: nb });
ReactDOM.createRoot(document.getElementById("root")!).render(
	<Router>
		<AuthProvider
			authority={import.meta.env.VITE_OIDC_AUTHORITY as string}
			client_id={import.meta.env.VITE_KEYCLOAK_CLIENTID as string}
			redirect_uri={window.location.href}
			userStore={oidcStateStore}
			automaticSilentRenew={true}
		>
			<QueryClientProvider client={new QueryClient()}>
				<ApolloClientProvider>
					<App />
				</ApolloClientProvider>
			</QueryClientProvider>
		</AuthProvider>
	</Router>
);
